import type { Router } from 'vue-router'
import { CustomerProposalList, ProductManageList } from './constant'
import { WorkspaceType, useWorkspaceStoreWithout } from '@/store/modules/workspace'

import { useAuthStoreWithout } from '@/store/modules/auth'
import useKnowledgeStore from '@/features/knowledgeBase/knowledge/store'
import { useUserStoreWithout } from '@/store/modules/user'

import { useQuickEntry } from '@/hooks/useQuickEntry'

export function checkPath(pathName: string, workspaceStore: any) {
  const enterpriseTypes = workspaceStore.enterpriseTypes
  function isBrandEnterprise(enterpriseTypes?: string[]): boolean {
    if (!enterpriseTypes || enterpriseTypes.length === 0) {
      return false
    }
    return enterpriseTypes.includes('BRAND')
  }
  if (!isBrandEnterprise(enterpriseTypes) && ProductManageList.includes(pathName)) {
    return 'WorkbenchView'
  } else if (isBrandEnterprise(enterpriseTypes) && CustomerProposalList.includes(pathName)) {
    return 'WorkbenchView'
  } else {
    return pathName
  }
}

const whiteList = [
  '/demo',
  '/auth-crx',
  '/auth',
  '/userInfo',
  '/invitation',
  '/company-invitation',
  '/404',
  '/chart-demo',
  '/user-protocol',
  '/privacy-policy',
]

export function setupPageGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    if (to.query.redirectSystem) {
      localStorage.setItem('redirectSystem', to.query.redirectSystem)
      localStorage.setItem('redirectSystemCode', to.query.systemCode)
    }
    if (whiteList.includes(to.path)) {
      next()
      return
    }

    const authStore = useAuthStoreWithout()
    const userStore = useUserStoreWithout()
    const workspaceStore = useWorkspaceStoreWithout()
    //
    const knowledgeStore = useKnowledgeStore()
    knowledgeStore.reset()

    // from.name = null 是页面刷新，会自动触发
    if ((to.name && from.name && to.name !== from.name && ((to.name !== 'Login' && to.name !== 'Auth' && to?.query?.workspace) || (to.name === 'Login' || to.name === 'Auth')))) {
      if (window.$posthog && userStore.userInfo.id) {
        window.$posthog.capture('$pageleave', {
          $current_url: `${window.location.origin}${from.fullPath}`,
        })
      }
    }

    if (!authStore.token) {
      // console.log('to.path', to.path, 'not login')
      window.$posthog?.reset(true) // reset the device_id so that the device will be considered a new device in future events
      if (to.path !== '/login') {
        // console.log('to ~~~~ login')
        next({ path: '/login', query: { redirect: encodeURIComponent(to.fullPath) } })
      } else {
        // console.log('to ~~~~ login else')
        next()
      }
    } else {
      try {
        await userStore.updateUserExtraInfo()

        // if (to.path === '/market-agent') {
        //   if (!workspaceStore.hasMarketAgentPermission) {
        //     next({ path: '/' })
        //     return
        //   }
        // }

        // 数选系统跳转
        if (to.query.redirect && (to.query.redirect as string).match(/https:\/\/dscm(test)?\.meiyeyanjiu.com/)) {
          const { handleClick } = useQuickEntry()
          handleClick({ code: 'dssc', url: decodeURIComponent(to.query.redirect as string), redirectUrl: decodeURIComponent(to.query.redirect as string) }, {
            callback: () => {
              window.location.href = decodeURIComponent(to.query.redirect as string)
            }
          })
        }

        if (to.path === '/login' || to.path === '/auth') {
          return next({ path: '/' })
        }
      } catch (error) {
        console.log(error, 'updateUserExtraInfo  -------------------->')
        // 清楚 token
        authStore.removeToken()

        // 重定向到登录页面
        next({ path: '/login' })
        return
      }

      if (userStore.userInfo.id === -1) {
        await userStore.getUserInfo()
      }

      // if (workspaceStore.workspaceList.length === 0) {
      // 获取工作空间列表
      await workspaceStore.updateWorkspaceList()
      // }

      if (userStore.dropMenuInfo.balance === -1) {
        userStore.updateDropMenuInfo()
      }

      if (userStore.userInfo.step === 0 && userStore.userInfo.skipCompleteWhitelist !== 1) {
        // 未完善信息且账号不在白名单里面
        if (to.path === '/login' || to.path === '/auth') {
          next()
          return
        } else if (to.path !== '/userInfo') {
          // 已登录下，如果点击过跳过填写信息的，放行
          const env = import.meta.env.VITE_ENV
          const SKIN_LOCAL_TOKEN_KEY = `${env}_user_info_skin_${userStore.userInfo.id}`

          const skipToken = localStorage.getItem(SKIN_LOCAL_TOKEN_KEY)
          if (skipToken && skipToken === authStore.token) {
            // next()
            // return
          } else {
            next({ path: '/userInfo', query: { redirect: encodeURIComponent(to.fullPath) } })
            return
          }
        }
      }

      // 有token 且 路由为login 重定向到工作台 WorkbenchView
      if (to.path === '/login') {
        if (to.query.redirect) {
          next({ path: decodeURIComponent(to.query.redirect as string) })
        } else {
          next({ name: 'WorkbenchView' })
        }
      } else {
        const hasWorkspace = workspaceStore.workspaceList?.find(item => item.workspaceType !== WorkspaceType.Check)
        // 有token 且 路由不为login 且 没有空间
        if (!workspaceStore.workspaceList.length || !hasWorkspace) {
          if (to.path === '/no-workspace' || to.path.includes('personal-center') || to.path === '/notify' || to.path.includes('productDetailMain') || to.path.includes('createProduct')) {
            next()
          } else {
            next({ name: 'NoWorkspaceView' })
          }
        } else if (workspaceStore.workspaceList.length && hasWorkspace && to.path === '/no-workspace') {
          // 有空间且页面为无空间页面时，跳转到首页
          next({ name: 'WorkbenchView' })
        } else {
          const urlWorkspaceId = to.query.workspace

          if (to.path !== from.path) {
            const workspaceId = workspaceStore.workspaceId
            // console.log('workspaceId', workspaceId, urlWorkspaceId)

            // urlWorkspaceId是否存在于空间列表中
            const urlWorkspaceObj = workspaceStore.workspaceList.find(item => item.workspaceId === Number(urlWorkspaceId))

            // 刷新页面
            if (from.path === '/' && urlWorkspaceId) {
              if (urlWorkspaceId !== String(workspaceId)) {
                if (urlWorkspaceObj && urlWorkspaceObj.workspaceType !== WorkspaceType.Check) {
                  // urlWorkspaceId存在空间列表里面且不是审核中，更新 Pinia store 中的 currentWorkspace
                  workspaceStore.updateCurrentWorkspaceById(urlWorkspaceId === 'null' ? null : Number(urlWorkspaceId))
                  if (urlWorkspaceObj.workspaceType === WorkspaceType.Personal && to.path.includes('company-management') || to.path.includes('company-product-member')) {
                    // 当前空间是个人空间，to.path是去企业管理（个人空间没有企业管理），跳转到首页
                    next({ name: 'WorkbenchView', query: { workspace: urlWorkspaceId } })
                  } else if (checkPath(to.name, workspaceStore) !== to.name) {
                    next({ name: 'WorkbenchView', query: { workspace: urlWorkspaceId } })
                  } else {
                    next()
                  }
                } else {
                  next({ name: 'WorkbenchView' })
                }
              } else {
                if (urlWorkspaceObj && urlWorkspaceObj.workspaceType !== WorkspaceType.Check) {
                  // 更新 Pinia store 中的 currentWorkspace
                  workspaceStore.updateCurrentWorkspaceById(urlWorkspaceId === 'null' ? null : Number(urlWorkspaceId))
                  if (urlWorkspaceObj.workspaceType === WorkspaceType.Personal && to.path.includes('company-management') || to.path.includes('company-product-member')) {
                    next({ name: 'WorkbenchView', query: { workspace: urlWorkspaceId } })
                  } else if (checkPath(to.name, workspaceStore) !== to.name) {
                    next({ name: 'WorkbenchView', query: { workspace: urlWorkspaceId } })
                  } else {
                    next()
                  }
                } else {
                  next({ name: 'WorkbenchView' })
                }
              }

              return
            }

            if (window.$posthog && userStore.userInfo.id) {
              const distinctId = window.$posthog.get_distinct_id()
              //  window.$posthog.persistence.props.$user_id
              if (distinctId !== userStore.userInfo.id) {
                window.$posthog.identify(userStore.userInfo.id, {
                  name: userStore.userInfo.nickName,
                })
              }
            }

            // 跳转增加workspace参数

            // 产品详情页，被邀请成功后，没有个人空间也可以查看
            if ((to.path.includes('productDetailMain') || to.path.includes('createProduct')) && urlWorkspaceId !== String(workspaceId) && workspaceStore.workspaceList.length) {
              if (urlWorkspaceObj) {
                // 更新 Pinia store 中的 currentWorkspace
                workspaceStore.updateCurrentWorkspaceById(urlWorkspaceId === 'null' ? null : Number(urlWorkspaceId))
                next()
              } else {
                next()
              }
            } else if ((workspaceId || workspaceId === null) && urlWorkspaceId !== String(workspaceId) && workspaceStore.workspaceList.length) {
              if (!urlWorkspaceId) {
                // url没有携带workspace， 加上workspace
                if (workspaceId && workspaceStore.workspaceList.find(item => item.workspaceId === workspaceId)) {
                  next({ path: to.path, query: { ...to.query, workspace: workspaceId } })
                } else {
                  // 空间列表有企业，选中第一个企业
                  const companyArr = workspaceStore.workspaceList?.filter(item => item.workspaceType === WorkspaceType.Company)
                  if (companyArr?.length) {
                    next({ path: to.path, query: { ...to.query, workspace: companyArr[0].workspaceId } })
                  } else {
                    next({ path: to.path, query: { ...to.query, workspace: workspaceStore.workspaceList[0].workspaceId } })
                  }
                }
              } else {
                // 判断urlWorkspaceId是否存在workspaceStore.workspaceList的id里面
                if (urlWorkspaceObj && urlWorkspaceObj.workspaceType !== WorkspaceType.Check) {
                  // 存在空间列表里面且不是审核中，更新 Pinia store 中的 currentWorkspace
                  workspaceStore.updateCurrentWorkspaceById(urlWorkspaceObj.workspaceId)
                  next()
                } else if (urlWorkspaceObj && urlWorkspaceObj.workspaceType === WorkspaceType.Check && (to.path === '/no-workspace' || to.path.includes('personal-center') || to.path === '/notify')) {
                  // 存在空间列表里面且是审核中，且是去无空间页或者个人信息页或者消息通知，放行
                  const nextQuery = {
                    ...to.query,
                    workspace: urlWorkspaceObj.workspaceId,
                  }
                  next({ query: nextQuery })
                } else {
                  // 携带的空间id不存在空间列表中，跳转去首页，id为空间列表的首个id
                  // 空间列表有企业，选中第一个企业
                  const companyArr = workspaceStore.workspaceList?.filter(item => item.workspaceType === WorkspaceType.Company)
                  if (companyArr?.length) {
                    // 更新 Pinia store 中的 currentWorkspace
                    workspaceStore.updateCurrentWorkspaceById(companyArr[0].workspaceId)
                    next({ name: 'WorkbenchView', query: { workspace: companyArr[0].workspaceId } })
                  } else {
                    const id = workspaceStore.workspaceList[0].workspaceId
                    // 更新 Pinia store 中的 currentWorkspace
                    workspaceStore.updateCurrentWorkspaceById(id)
                    next({ name: 'WorkbenchView', query: { workspace: id } })
                  }
                }
              }
            } else if (checkPath(to.name, workspaceStore) !== to.name) {
              next({ name: 'WorkbenchView' })
            } else {
              next()
            }
          } else {
            next()
          }
        }
      }
    }
  })

  router.afterEach((to, from) => {
    //  from.path === '/' 这是刷新页面的情况，会自动触发，不需要手动触发
    if (window.$posthog && from.path !== '/') {
      window.$posthog.capture('$pageview', {
        $current_url: window.location.href,
      })
    }
  })
}
